const imgCheck = () => {
  try {
    return (
      document
        .createElement('canvas')
        .toDataURL('image/webp')
        .indexOf('data:image/webp') == 0
    );
  } catch (err) {
    return false;
  }
};
function fillJsfImage(jsfImage: string) {
  // 是否支持webp图片
  const isWebp = imgCheck() ? '!q70.webp' : '!q70';
  if (!jsfImage) {
    return undefined;
  }
  return `//m.360buyimg.com/uba/${jsfImage}${isWebp}`;
}

export default fillJsfImage;
